import {useApp} from '../../../contexts/AppContext';
import {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import config from '../../../config';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import {ReportContextProvider} from '../../../contexts/ReportContext';
import moment from 'moment';
import ReactQuill from 'react-quill';
import './index.scss';
import {
  PageMainTitle,
  SubInner,
  InputLabel,
  FormTextArea,
  RequiredLabel,
  FormInput,
} from '../../atoms/CommonParts';

const Page = styled.div`

`;

const NewsSection = styled.div`
  margin-top: 40px;
  @media ${config.layout.wide} {
    margin-top: 57px;
  }
`;

const NewsItem = styled.div`
  margin-bottom: 40px;
  border-radius: 2px;
  border: 1px solid #000000;

  .title-block {
    padding: 30px 20px 30px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    cursor: pointer;

    .title-contents {
      flex: 2 1 auto;
      font-weight: bold;

      .date {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 10px;
      }

      .title {
        font-size: 24px;
        line-height: 32px;
        //        overflow: hidden;
        //        display: -webkit-box;
        //        -webkit-box-orient: vertical;
        //        -webkit-line-clamp: 2;
      }
    }
  }

  .description-block {
    display: none;
    padding: 30px 20px 40px;
    position: relative;

    &:before {
      content: '';
      display: block;
      position: absolute;
      width: calc(100% - 40px);
      height: 1px;
      background-color: #000000;
      top: 0;
      left: 20px;
    }

    .description {
      font-weight: 500;
      font-size: 16px;
      line-height: 26px;
      white-space: pre-wrap;

      a {
        color: #000000;
      }

      ul, ol {
        list-style: revert;
      }

      strong {
        font-weight: bold;
      }

      .ql-clipboard {
        display: none;
      }
    }

    .links {
      margin-top: 30px;

      a {
        &:last-child {
          margin-bottom: 0;
        }

        display: block;
        margin-bottom: 20px;
        color: #000000;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;
        line-height: 19px;

        display: flex;
        align-items: center;
        gap: 10px;

        .label {
          flex: 1 1 auto;
          word-break: break-all;
        }
      }
    }
  }

  &.expanded {
    .description-block {
      display: block;
    }
  }
`;

const LinkIcon = styled.div`
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11.375' height='19.719' viewBox='0 0 11.375 19.719'%3E%3Cpath id='パス_44' data-name='パス 44' d='M1.515,0,0,1.515,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
  display: block;
  width: 6px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex: 0 0 auto;
`;

const ExpandIcon = styled.div`
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19.719" height="11.375" viewBox="0 0 19.719 11.375"><path id="パス_404" data-name="パス 404" d="M1.516,0,0,1.516,8.344,9.859,0,18.2l1.516,1.516,9.859-9.859Z" transform="translate(0 11.375) rotate(-90)"/></svg>');
  display: block;
  width: 12px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: center;
  flex: 0 0 auto;
`;

export default function NewsPage() {
  const app = useApp();

  useEffect(() => {
    app.showHeader();
    document.title = 'News';
    app.refreshNews();
  }, []);

  return (
      <Page>
        <PageMainTitle><span>News</span></PageMainTitle>

        <NewsSection>
          {
            app.state.news.map(n => {
              return (
                  <NewsItem
                      key={n.venuenews_id}
                      className={n.expanded ? 'expanded' : 'collapsed'}
                  >
                    <div className={'title-block'}
                         onClick={() => {
                           app.toggleNewsExpand(n.venuenews_id);
                         }}>
                      <div className={'title-contents'}>
                        <div className={'date'}>{moment(n.display_datetime).
                            utc().
                            format('YYYY/MM/DD')} </div>
                        <div className={'title'}>{n.title_en}</div>
                      </div>
                      <ExpandIcon
                          className={n.expanded
                              ? 'news-expand-icon expanded'
                              : 'news-expand-icon collapsed'}
                      />
                    </div>
                    <div className={'description-block'}>
                      <div className={'description'}>
                        {
                          typeof n.description_en == 'string' ? (
                              <div className={'plain'}>
                                {n.description_en}
                              </div>
                          ) : (
                              <div className={'quill'}>
                                <ReactQuill
                                    theme={null}
                                    formats={['bold', 'italic', 'link', 'list']}
                                    value={n.description_en}
                                    readOnly={true}
                                />
                              </div>
                          )
                        }
                      </div>
                      <div className={'links'}>
                        {
                          n.links.map((l, i) => {
                            return (<a
                                    key={i}
                                    href={l.url}
                                    target={'_blank'}>
                                  <LinkIcon/>
                                  <div className={'label'}>{l.label}</div>
                                </a>
                            );
                          })
                        }
                      </div>
                    </div>
                  </NewsItem>
              );
            })
          }
        </NewsSection>
      </Page>
  );
}